import { katTranslator } from '../../shared/i18n';

const strings = {
  'kat-filter-bar-apply': {
    'en-US': 'Apply',
    'ar-AE': 'تطبيق',
    'bn-IN': 'প্রয়োগ করুন',
    'de-DE': 'Anwenden',
    'es-ES': 'Aplicar',
    'es-MX': 'Aplicar',
    'fr-BE': 'Appliquer',
    'fr-FR': 'Appliquer',
    'gu-IN': 'લાગુ કરો',
    'hi-IN': 'लागू करें',
    'it-IT': 'Applica',
    'ja-JP': '適用',
    'kn-IN': 'ಅನ್ವಯಿಸಿ',
    'ko-KR': '적용',
    'ml-IN': 'ബാധകമാക്കുക',
    'mr-IN': 'लागू करा',
    'nl-BE': 'Toepassen',
    'nl-NL': 'Toepassen',
    'pl-PL': 'Zastosuj',
    'pt-BR': 'Aplicar',
    'pt-PT': 'Aplicar',
    'sv-SE': 'Tillämpa',
    'ta-IN': 'பயன்படுத்து',
    'te-IN': 'వర్తింపజేయండి',
    'th-TH': 'ปรับใช้',
    'tr-TR': 'Uygula',
    'vi-VN': 'Áp dụng',
    'zh-CN': '应用',
    'zh-TW': '套用',
  },
  'kat-filter-bar-clear': {
    'en-US': 'Clear',
    'ar-AE': 'مسح',
    'bn-IN': 'মুছে ফেলুন',
    'de-DE': 'Löschen',
    'es-ES': 'Borrar',
    'es-MX': 'Borrar',
    'fr-BE': 'Effacer',
    'fr-CA': 'Effacer',
    'fr-FR': 'Transparente',
    'gu-IN': 'સાફ કરો',
    'hi-IN': 'हटाएं',
    'it-IT': 'Cancella',
    'ja-JP': '取り消す',
    'kn-IN': 'ಕ್ಲಿಯರ್ ಮಾಡಿ',
    'ko-KR': '지우기',
    'ml-IN': 'മായ്ക്കുക',
    'mr-IN': 'साफ करा',
    'nl-BE': 'Wissen',
    'nl-NL': 'Wissen',
    'pl-PL': 'Wyczyść',
    'pt-BR': 'Limpar',
    'pt-PT': 'Limpar',
    'sv-SE': 'Rensa',
    'ta-IN': 'அழி',
    'te-IN': 'క్లియర్ చేయండి',
    'th-TH': 'ล้าง',
    'tr-TR': 'Temizle',
    'vi-VN': 'Rõ ràng',
    'zh-CN': '清除',
    'zh-TW': '清除',
  },
  'kat-filter-bar-search': {
    'en-US': 'Search',
    'ar-AE': 'بحث',
    'bn-IN': 'অনুসন্ধান করুন',
    'de-DE': 'Suchen',
    'es-ES': 'Buscar',
    'es-MX': 'Buscar',
    'fr-BE': 'Rechercher',
    'fr-CA': 'Rechercher',
    'fr-FR': 'Rechercher',
    'gu-IN': 'શોધો',
    'hi-IN': 'सर्च करें',
    'it-IT': 'Cerca',
    'ja-JP': '検索',
    'kn-IN': 'ಸರ್ಚ್ ಮಾಡಿ',
    'ko-KR': '검색',
    'ml-IN': 'തിരയുക',
    'mr-IN': 'शोधा',
    'nl-BE': 'Zoeken',
    'nl-NL': 'Zoeken',
    'pl-PL': 'Szukaj',
    'pt-BR': 'Pesquisar',
    'pt-PT': 'Pesquisar',
    'sv-SE': 'Sök',
    'ta-IN': 'சர்ச்',
    'te-IN': 'వెతకండి',
    'th-TH': 'ค้นหา',
    'tr-TR': 'Ara',
    'vi-VN': 'Tìm kiếm',
    'zh-CN': '搜索',
    'zh-TW': '搜尋',
  },
  'kat-filter-bar-create': {
    'en-US': 'Create',
  },
  'kat-filter-bar-edit': {
    'en-US': 'Edit',
  },
};

export default katTranslator(strings);
